import Vue from "vue";
import moment from "moment";
import store from "../store/index";
export default class common {
  static logOut() {
    store.dispatch("setUserToken", null);
    store.dispatch("setBotId", null);
    store.dispatch("setRoleId", null);
    store.dispatch("setAllBots", null);
    localStorage.setItem("userToken", "");
    localStorage.setItem("setBotId", "");
    localStorage.setItem("botId", "");
    localStorage.setItem("roleId", "");
    localStorage.setItem("allBots", "");
    window.location.href = "/";
    Vue.prototype.$http.post("/auth/logout");
  }

  static isEquivalent(a, b) {
    // Create arrays of property names
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
      return false;
    }

    for (let i = 0; i < aProps.length; i++) {
      let propName = aProps[i];

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
  }

  static validURL(str) {
    let regexp =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(str);
  }

  static formatDateTime(Data) {
    const formattedDateTime = new Date(Data).toGMTString();
    return `${formattedDateTime}`;
  }

  static serialize(obj) {
    let str = [];
    for (let p in obj)
      if (obj.hasOwnProperty(p) && obj[p]) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  static serializeWithFalseValues(obj) {
    let str = [];
    for (let p in obj)
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    return str.join("&");
  }

  static get_yt_iframe_from_url(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  }

  static getTextAlignment(text) {
    // console.log(text)
    let arabic = /[\u0600-\u06FF]/;
    if (arabic.test(text.charAt(0))) {
      return "botter-rtl";
    } else {
      return "botter-ltr";
    }
  }

  static formatText(text) {
    let newText;

    if (text.includes("TEMPLATE_MESSAGE")) {
      let template_message_id = text.split(" ")[1];
      newText = `<a href="/campaigns/template-messages/${template_message_id}/editor" target="blank"> ${text}</a>`;
      return newText;
    }
    newText = this.replaceSpecialChars(text, "*", "<b>", "</b>");
    newText = this.replaceSpecialChars(newText, "_", "<i>", "</i>");
    newText = this.replaceSpecialChars(newText, "~", "<del>", "</del>");
    return newText;
  }

  static replaceSpecialChars(text, char, replaceStart, replaceEnd) {
    let count = 0;
    for (let i = 0; i < text.length; i++) {
      if (text.charAt(i) === char) {
        count++;
        if (count % 2 === 0) {
          text = this.replaceCharIndex(text, i, replaceEnd);
        } else {
          text = this.replaceCharIndex(text, i, replaceStart);
        }
      }
    }
    return text;
  }

  static replaceCharIndex(string, index, replacement) {
    return string.substr(0, index) + replacement + string.substr(index + 1);
  }

  static formatAMPM(date) {
    return moment(date).format("D/M/YYYY hh:hh A");
  }

  static formatDate(date) {
    let time = this.formatAMPM(date);
    return time;
  }

  static timeAgo(dateParam) {
    if (!dateParam) {
      return null;
    }

    const date =
      typeof dateParam === "object" ? dateParam : new Date(dateParam);

    if (store.state.settings.settings.timeZoneShift) {
      date.setHours(
        date.getHours() + parseInt(store.state.settings.settings.timeZoneShift)
      );
    }
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();

    if (seconds < 5) {
      return this.getFormattedDate(date, true);
    } else if (seconds < 60) {
      return this.getFormattedDate(date, true);
    } else if (seconds < 90) {
      return this.getFormattedDate(date, true);
    } else if (minutes < 60) {
      return this.getFormattedDate(date, true);
    } else if (isToday) {
      return this.getFormattedDate(date, true); //  at 10:20
    } else if (isYesterday) {
      return this.getFormattedDate(date, false, true); // Yesterday at 10:20
    } else if (isThisYear) {
      return this.getFormattedDate(date, false, true); // 10. January at 10:20
    }

    return this.getFormattedDate(date); // 10. January 2017. at 10:20
  }

  static getFormattedDate(date, prefomattedDate = false, hideYear = false) {
    const MONTH_NAMES = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();

    if (minutes < 10) {
      // Adding leading zero to minutes
      minutes = `0${minutes}`;
    }

    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    if (prefomattedDate) {
      // Today at 10:20
      // Yesterday at 10:20
      return `${hours}:${minutes} ${ampm} `;
    }

    if (hideYear) {
      // 10. January at 10:20
      return `${day} ${month} `;
    }

    // 10. January 2017. at 10:20
    return `${day} ${month} ${year} `;
  }

  static throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }

  static checkDataValid(validObject, receivedObject) {
    for (let key in validObject) {
      // console.log(typeof validObject[key] )
      if (
        typeof validObject[key] === "object" &&
        !Array.isArray(validObject[key]) &&
        validObject[key] !== null
      ) {
        let valid = this.checkDataValid(validObject[key], receivedObject[key]);
        if (!valid) {
          return false;
        }
      } else {
        if (
          !receivedObject.hasOwnProperty(key) ||
          receivedObject[key] === null
        ) {
          return false;
        }
      }
    }
    return true;
  }

  static hasPermissions(permission, actions = []) {
    const userPermissions = store.state.user.userData.permissions;
    if (userPermissions["*"] && userPermissions["*"].length) return true;
    if (userPermissions[permission]) {
      if (!actions.length) return true;
      return actions.every((i) => userPermissions[permission].includes(i));
    }
    return false;
  }

  static isRole(role) {
    return store.state.user.userData.role == role;
  }
}
